<template lang="html">
  <div>
    <div v-if="globalC.callsm" class="card">
      <div class="callus">
        <div class="callus-col-2">
          <div class="callus-col">
            <div v-html="compiledMarkdown(globalC.callsm.content)">

            </div>
            <a :href="'tel:'+globalC.callsm.phone" class="callus-icon">{{globalC.callsm.phone}}</a>
          </div>
          <div class="callus-col">
            <img class="callus-img" :src="globalC.callsm.img" alt="">
          </div>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Permissionphone from '../permissionPhone.vue';
import Marked from 'marked';
import {mapGetters} from 'vuex';
export default {
  name: 'CallUs',
  components: {
    appPermissionphone: Permissionphone
  },
  data () {
    return {
      showPhoneForm:false
    }
  },
  computed: {
      ...mapGetters([
        'globalC'
      ])
  },
  methods:{
    compiledMarkdown(text) {
      return Marked(text, { sanitize: true })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/modular/call-us-sm.vue